



























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { User } from '@/models/user';
import type { CompanySetting } from '@/models/companySetting';
import { companyWebservice } from '@/webservices/company';
import type { Company } from '@/models/company';

@Component({
    name: 'UpdateDynamicFieldName',
})
export default class UpdateDynamicFieldName extends Vue {
    // Data
    protected locked: boolean = true;
    protected errorMsg: string = '';
    protected dynamicFieldName: string = '';

    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/companySetting') private companySetting: CompanySetting;

    private mounted() {
        companyWebservice.getCompanyByUser().then((response) => {
            const company: Company = response && response.data;
            const name = company.setting.dynamic_worksheet_field_name;
            this.dynamicFieldName = name ? name : '';
        });
    }
    private save() {
        if (this.companySetting.dynamic_worksheet_field_name.length === 0) {
            return false;
        }

        if (this.companySetting.dynamic_worksheet_field_name === this.dynamicFieldName) {
            this.locked = true;
            return false;
        }
        companyWebservice.updateDynamicFieldName(this.dynamicFieldName).then((response) => {
            location.reload();
        });
    }
}
